import React, { FC } from 'react'
import { Box, breakpoints, Image, Heading, theme, linkStyle } from '@gassan-ui'
import styled from 'styled-components'
import { useLocalization } from './Localization'
import { gridColumn, GridColumnProps } from 'styled-system'

const StyledImage = styled(Image)`
  opacity: 1;
  transition: all 0.3s ease;
`

const Block = styled(Box)<GridColumnProps>`
  ${gridColumn};
  background-color: ${p => p.theme.colors.oldLace};
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-top: 68%;

  @media screen and (min-width: ${breakpoints.large}) {
    padding-top: 140%;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover,
    &:focus {
      ${StyledImage} {
        opacity: 0.8;
      }
    }
  }
`

const LinkSpan = styled.span`
  ${linkStyle};
  border-bottom: 1px solid currentColor;
  color: currentColor;
`

type Props = {
  mobileImage: string
  desktopImage: string
  title: string
  href: string
  contentPosition: 'top' | 'bottom'
  variant: 'light' | 'dark'
}

const ProductGridCTABlock: FC<Props> = ({
  title,
  href,
  mobileImage,
  desktopImage,
  contentPosition,
  variant
}) => {
  const { messages } = useLocalization()
  return (
    <Block
      gridColumn={['1 / span 2', '1 / span 2', '1 / span 2', 'inherit']}
      title={title}
      as="a"
      href={href}
    >
      <Box
        position="absolute"
        height={{
          _: 'calc(100% - 2rem)',
          small: 'calc(100% - 4rem)',
          large: 'calc(100% - 2rem)',
          xlarge: 'calc(100% - 4rem)'
        }}
        width={{
          _: 'calc(100% - 2rem)',
          small: 'calc(100% - 4rem)',
          large: 'calc(100% - 2rem)',
          xlarge: 'calc(100% - 4rem)'
        }}
        top={{
          _: '1rem',
          small: '2rem',
          large: '1rem',
          xlarge: '2rem'
        }}
        left={{
          _: '1rem',
          small: '2rem',
          large: '1rem',
          xlarge: '2rem'
        }}
      >
        <Box position="relative" height="100%" width="100%">
          <StyledImage
            zIndex={0}
            alt={title}
            height="100%"
            width="100%"
            position="absolute"
            sources={[mobileImage, mobileImage, desktopImage]}
          />
          <Box
            position="absolute"
            color={variant === 'dark' ? theme.colors.shades[800] : 'white'}
            left={{
              _: '1rem',
              small: '2.5rem',
              large: '1rem',
              xlarge: '2rem'
            }}
            bottom={
              contentPosition === 'bottom' && {
                _: '1rem',
                small: '2.5rem',
                large: '2rem'
              }
            }
            top={
              contentPosition === 'top' && {
                _: '1rem',
                small: '2.5rem',
                large: '2rem'
              }
            }
            width={{
              _: 'calc(100% - 2rem)',
              small: 'calc(100% - 5rem)',
              large: 'calc(100% - 2rem)',
              xlarge: 'calc(100% - 5rem)'
            }}
          >
            <Heading variant="h3" as="h3" color="currentColor" mb="0.5rem">
              {title}
            </Heading>
            <LinkSpan>{messages.global.view}</LinkSpan>
          </Box>
        </Box>
      </Box>
    </Block>
  )
}

export default ProductGridCTABlock
